import { createFileRoute } from "@tanstack/react-router"
import ConversationSalesReports from "modules/backoffice/components/conversationSalesReports"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/conversationSalesReports")({
  component: ConversationSalesReports,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.conversationSalesReports.title"),
    })
  },
})
